import { render } from "./AssignTraderToDealModal.vue?vue&type=template&id=69a9fc6a&ts=true"
import script from "./AssignTraderToDealModal.vue?vue&type=script&lang=ts"
export * from "./AssignTraderToDealModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__